<template>
    <div class="content-wapper">
        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">小微驿站</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/xwqyczfw/djyl' }">党建引领</el-breadcrumb-item>
                    <el-breadcrumb-item>{{dictFormatTitle()}}详情</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>

        <el-row class="content">
            <h1 style="font-family: 微软雅黑, 宋体">{{detail.djylglTitle}}</h1>
            <el-row class="soure">
                <span style="padding-right: 105px;">发布时间：{{ parseTime(detail.djylglFbtime, '{y}-{m}-{d}') }}</span><span style="padding-right: 105px;">访问量：{{browseCount}}</span><span>来源：{{fbDept}}</span>
            </el-row>
            <div v-html="detail.djylglContent" class="eidt-content"></div>
        </el-row>

    </div>
</template>

<script>
    import { getDjylgl} from "@/api/xwqy/djylgl";
    export default {
        name: "detail",
        data() {
            return {
                // 遮罩层
                loading: true,
                recid:undefined,
                type:undefined,
                detail:{},
                browseCount:undefined,
                menulist:[
                    {code:'tzgg',title:'通知公告',icon:'el-icon-reading'},
                    {code:'bzgb',title:'表彰通报',icon:'el-icon-reading'},
                    {code:'gqsdjgz',title:'各区市党建工作',icon:'el-icon-reading'},
                    {code:'gtsyqydjgz',title:'个体私营企业党建工作',icon:'el-icon-reading'},
                    {code:'cxgs',title:'撤销公示',icon:'el-icon-reading'}
                ],
                fbDept: '威海市市场监督管理局',
            }
        },
        created() {
            this.type = this.$route.params && this.$route.params.djyltype;
            this.recid = this.$route.params && this.$route.params.recid;
            this.getDetail();
        },
        methods: {
            toPage(url){
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            refresh(){
                this.getDetail();
            },
            getDetail(){
                let recid = this.recid;
                getDjylgl(recid).then(response => {
                    this.detail = response.data.data;
                    this.browseCount = response.data.browseCount;
                });
            },
            dictFormatTitle() {
                let that=this;
                let title='';
                Object.keys(that.menulist).map((key) => {
                    if (that.menulist[key].code == that.type) {
                        title=that.menulist[key].title;
                        return false;
                    }
                })
                return title;
            }
        }
    }
</script>

<style scoped>
    .content-wapper{
        margin-top: 5px;
        padding: 10px;
    }
    .navigation{
        padding:20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }
    .content{
        border: 1px solid #cccccc;
        padding:20px 80px;
    }
    .soure{
        background-color:#f3f3f3;
        padding:10px;
        margin: 25px 0;
    }
    /* table 样式 */
    table {
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
    }
    /deep/ table td,
    /deep/ table th {
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
        padding: 3px 5px;
    }
    /deep/ table th {
        border-bottom: 2px solid #ccc;
        text-align: center;
    }
    .eidt-content{
        text-align: left;
    }
</style>